import axios from 'axios';
import { ref } from 'vue'
//需要拦截器的地方使用instance对象， 有自定义返回逻辑的地方沿用axios，在组件内部处理返回结果即可
import instance from './filter'
//获取首页Banner轮播图
const json = ref("/json")
//const http = ref("http://localhost:7070/api")
//const http = ref("http://localhost:5209/api")
//const http = "http://localhost:5209/api"   
//const http = "http://39.108.0.201:54010/api" 
//const http =  'http://localhost:54010/api'     //本地开发 本地接口 用这个
//const http = "http://39.108.0.201:54009/api"   //这个配合api jwt配置http://39.108.0.201:54009可以
const http = "http://flower.520mus.top:54009/api" //发布用这个
export const getBanners = () => {
    //return axios.get(json.value + "/banner.json");
    return axios.get(http+ "/banner.json");
}
export const getBanners2 = () => {
    return axios.get(http + "/Image/GetImages");
}
export const getFlowers = (parms: {}) => { 
    return axios.post(http + "/Flower/GetFlowers", JSON.stringify(parms) 
    ,{
        headers:{
          'Content-Type':"application/json;charset=UTF-8"
        }
      }
    ); 
}
export const Register = (parms: {}) => {
    return axios.post(http + "/Login/Register", JSON.stringify(parms) 
    ,{
        headers:{
          'Content-Type':"application/json;charset=UTF-8"
        }
      }); 
}
export const getToken = (parms: {}) => {
  return axios.post(http + "/Login/Check", JSON.stringify(parms)
    ,{
        headers:{
          'Content-Type':"application/json;charset=UTF-8"
        }
      }
      ); 
    // return axios.post(http + "/Login/Check", JSON.stringify(parms) 
    // ,{
    //     headers:{
    //       'Content-Type':"application/json;charset=UTF-8"
    //     }
    //   }); 
}
//生成一笔订单
export const CreateOrder = (parms: {}) => {
    //在header里携带token访问后端接口
    
    axios.defaults.headers.common['Authorization'] = "Bearer " + localStorage["token"];
    return axios.post(http + "/Order/CreateOrder",  parms,{
      headers:{
        'Content-Type':"application/json;charset=UTF-8"
      }
    });
}

export const CreateOrderreturnorder = (parms: {}) => {
  //在header里携带token访问后端接口
  
  axios.defaults.headers.common['Authorization'] = "Bearer " + localStorage["token"];
  return axios.post(http + "/Order/CreateOrderreturnorder",  parms,{
    headers:{
      'Content-Type':"application/json;charset=UTF-8"
    }
  });
}
//获取订单列表
export const GetOrder = (parms: {} ) => {
    // //在header里携带token访问后端接口
    // instance.defaults.headers.common['Authorization'] = "Bearer " + localStorage["token"];
    // return instance.post(http + "/Order/GetOrder",parms,{
    //   headers:{
    //     'Content-Type':"application/json;charset=UTF-8"
    //   }
    // });
    axios.defaults.headers.common['Authorization'] = "Bearer " + localStorage["token"];
    return axios.post(http + "/Order/GetOrder",parms,{
      headers:{
        'Content-Type':"application/json;charset=UTF-8"
      }
    });
}